import React, { createContext, useState, useContext } from 'react';

const HelpContext = createContext();

export const HelpProvider = ({ children }) => {
  const [helpConfig, setHelpConfig] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const triggerHelp = (config) => {
    setHelpConfig(config);
    setIsOpen(true);
  };

  const closeHelp = () => setIsOpen(false);

  return (
    <HelpContext.Provider value={{ triggerHelp, closeHelp, isOpen, helpConfig }}>
      {children}
    </HelpContext.Provider>
  );
};

export const useHelp = () => useContext(HelpContext);